import { graphql } from 'msw';
import comments from './comments';

export const uxlHandlers = [
  graphql.query('GetComments', (req, res, ctx) => {
    return res(ctx.data(comments));
  }),
];
